import { InboxPage } from "@khazzin/ui/patterns";
import { useNavigate } from "react-router";
import { useApi } from "../../api";
import { useI18n } from "../../i18n";
import { timeZone } from "./Shell";

/**
 * `/inbox` (EP12-S15, deferred here by EP12-S03): the driver's own
 * notifications, the console's page. A push no device took lands here
 * (EP12-S07); a row about a stop opens it.
 */
export function DriverInbox() {
	const { t, locale } = useI18n();
	const navigate = useNavigate();
	return (
		<InboxPage
			api={useApi()}
			t={t}
			locale={locale}
			timeZone={timeZone}
			onNavigate={(to) => void navigate(to)}
		/>
	);
}
